export default "__VITE_ASSET__VkpRu1Dq__"